import React, { useState } from "react";
import "../css/members.css";
import logo1 from "../assets/logo.png";
import { FaSearch } from "react-icons/fa";
import subashImg from "../assets/members/subash.jpeg";
import memberImg from "../assets/members/image.png";

export default function Members() {
  const [search, setSearch] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const [monthIndex, setMonthIndex] = useState(new Date().getMonth());

  const months = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  const members = [
    { id: 1, name: "Subash", role: "பேரூர் செயலாளர்", image: subashImg},
    { id: 2, name: "Rabincis", role: "பேரூர் இணைச் செயலாளர்", image: memberImg},
    { id: 3, name: "Christin Raj", role: "பேரூர் பொருளாளர்", image: memberImg},
    { id: 4, name: "Vishnu Kumar", role: "மாவட்ட வெளிநாடு வாழ் மக்கள் அணி அமைப்பாளர்", image: memberImg},
    { id: 5, name: "Satheesh", role: "பேரூர் திருவட்டார் வடக்கு ஒன்றிய செயற்குழு உறுப்பினர்", image: memberImg},
    { id: 6, name: "Raja", role: "பேரூர் துணைச் செயலாளர்", image: memberImg},
    { id: 7, name: "Anija", role: "பேரூர் துணைச் செயலாளர்", image: memberImg},
    { id: 8, name: "Shiny", role: "10 வது வார்டு கிளைச்செயலாளர்", image: memberImg},
    { id: 9, name: "Abishek", role: "பேரூர் செயற்குழு உறுப்பினர்", image: memberImg},
    { id: 10, name: "Satheesh", role: "பேரூர் செயற்குழு உறுப்பினர்", image: memberImg},
    { id: 11, name: "Aswin", role: "பேரூர் செயற்குழு உறுப்பினர்", image: memberImg},
    { id: 12, name: "Jenifer", role: "பேரூர் செயற்குழு உறுப்பினர்", image: memberImg},
    { id: 13, name: "Kishiyon Abi", role: "பேரூர் செயற்குழு உறுப்பினர்", image: memberImg},
    { id: 14, name: "Ajith", role: "பேரூர் செயற்குழு உறுப்பினர்", image: memberImg},
    { id: 15, name: "Vishnu", role: "பேரூர் செயற்குழு உறுப்பினர்", image: memberImg},
    { id: 16, name: "Ratheesh", role: "பேரூர் செயற்குழு உறுப்பினர்", image: memberImg},
  ];

  const filteredMembers = members.filter((m) =>
    m.name.toLowerCase().includes(search.toLowerCase())
  );

    const attendanceData = [
      "present","present","absent","present","present",
      "absent","present","present","present","absent",
      "present","present","absent","present","present",
      "present","absent","present","present","present",
      "absent","present","present","present","present",
      "absent","present","present","present","present"
    ];


  return (
    <div className="members-container">

      <div className="members-header">
        <img src={logo1} alt="logo" className="members-logo"/>
      </div>

      <div className="members-search-box">
        <FaSearch/>
        <input
          type="text"
          placeholder="Search members..."
          value={search}
          onChange={(e)=>setSearch(e.target.value)}
        />
      </div>

      <div className="members-grid">
        {filteredMembers.map((member)=>(
          <div
            key={member.id}
            className="members-card"
            onClick={()=>setSelectedMember(member)}
          >
          <div className="members-avatar">
            <img src={member.image} alt={member.name} />
          </div>

            <h4>{member.name}</h4>
            <p className="members-role">{member.role}</p>
          </div>
        ))}
      </div>

      {selectedMember && (
        <div className="members-modal">

          <div className="members-modal-card">

            <div className="members-modal-header">
              <button onClick={()=>setMonthIndex((m)=>(m-1+12)%12)}>◀</button>
              <h3>{months[monthIndex]} 2026</h3>
              <button onClick={()=>setMonthIndex((m)=>(m+1)%12)}>▶</button>
            </div>

            <h4>{selectedMember.name}</h4>

            <div className="members-attendance-grid">
              {attendanceData.map((day,i)=>(
                <div
                  key={i}
                  className={day === "present" ? "members-dot present" : "members-dot absent"}
                >
                  {i + 1}
                </div>
              ))}
            </div>

            <button
              className="members-close-btn"
              onClick={()=>setSelectedMember(null)}
            >
              Close
            </button>

          </div>
        </div>
      )}

    </div>
  );
}